import { fill, scale } from "@cloudinary/url-gen/actions/resize"
import { max } from "@cloudinary/url-gen/actions/roundCorners"
import { focusOn } from "@cloudinary/url-gen/qualifiers/gravity"
import { faces } from "@cloudinary/url-gen/qualifiers/focusOn"
import { CloudinaryImage } from "@cloudinary/url-gen"
import { lazyload } from "@cloudinary/react"

export const onlineCourseImg = new CloudinaryImage(
  "hero-images/course-on-screen-3_rm9idh",
  { cloudName: "coastline-academy" },
)
  .resize(fill(250, 250).gravity(focusOn(faces())))
  .roundCorners(max())
  .quality(80)
  .format("auto")

export const dmvApprovedImg = new CloudinaryImage(
  "misc-images/drivers-ed-hero-showcase-2.c4211073_zbpekx",
  { cloudName: "coastline-academy" },
)
  .resize(fill(550))
  .quality(80)
  .format("auto")

export const coastAcademyVehicleImg = new CloudinaryImage(
  "vehicle-images/coastline-vehicle-new-branding-2_owxfsq",
  { cloudName: "coastline-academy" },
)
  .resize(fill(600))
  .quality(80)
  .format("auto")

export const coastlineLogoImg = new CloudinaryImage(
  "logos/Coastline_Logomark_Navy_square_s1suxp",
  { cloudName: "coastline-academy" },
)
  .resize(fill(100, 100))
  .format("auto")
  .quality("auto")

export const vehicleCorrolaImg = new CloudinaryImage(
  "vehicle-images/coastline-vehicle-new-branding-1_wzli9e",
  { cloudName: "coastline-academy" },
)
  .resize(fill(500, 200))
  .quality(80)
  .format("auto")

export const caLogoImg = new CloudinaryImage(
  "logos/Coastline_Logomark_Teal_square_xgtl6b",
  { cloudName: "coastline-academy" },
)
  .resize(scale(80, 80))
  .quality(80)
  .format("auto")

export const lazyLoadPreset = lazyload({
  rootMargin: "0px",
  threshold: 0.25,
})
